import Client from "fhir-kit-client";

// Client
const fhirClient = new Client({
  baseUrl: process.env.REACT_APP_FHIR_URL ?? "fhir",
});

// Bundle helpers
function extractResources<T>(
  bundle: any,
  resourceType: string
): T[] {
  if (!bundle?.entry || !Array.isArray(bundle.entry)) {
    return [];
  }

  return bundle.entry
    .map((entry: any) => entry?.resource)
    .filter(
      (resource: { resourceType?: string } | undefined) =>
        resource?.resourceType === resourceType
    ) as T[];
}

function hasNextPage(bundle: any): boolean {
  return Array.isArray(bundle?.link)
    ? bundle.link.some((link: any) => link?.relation === "next" && link?.url)
    : false;
}

// Resource loaders
export async function loadResource<T>(
  resourceType: string,
  id: string
): Promise<T> {
  return fhirClient.read({
    resourceType,
    id: id ?? "",
  }) as Promise<T>;
}

export async function loadAllResources<T>(
  resourceType: string,
  searchParams: Record<string, string>
): Promise<T[]> {
  const resources: T[] = [];
  let bundle = (await fhirClient.search({
    resourceType,
    searchParams,
  })) as any;

  resources.push(...extractResources<T>(bundle, resourceType));

  while (hasNextPage(bundle)) {
    bundle = (await fhirClient.nextPage({ bundle })) as any;
    resources.push(...extractResources<T>(bundle, resourceType));
  }

  return resources;
}
